<template>
    <div>
        <ul>
            <li class="form-label">{{ $t('Media List') }}</li>
            <li>
                <cic-select
                    id="route_mapping_type"
                    :enabled="editing"
                    :options="mediaLists.map((x) => ({ value: x.mediaListId, label: x.name }))"
                    :placeholder="$t('Select media list...')"
                    :value="route.mappingType > 0 ? route.mappingType : null"
                    @input="(val) => updateFieldValue('mappingType', val)"
                />
            </li>
            <li v-if="warning">
                {{ $t('* Selected media list is restricted') }}
            </li>
            <li class="form-label">{{ $t('Prompt') }}</li>
            <li>
                <cic-select
                    id="route_mapping"
                    :enabled="editing && !warning"
                    :options="prompts.map((x) => ({ value: x.id, label: x.name }))"
                    :placeholder="$t('Please select...')"
                    :value="route.mappingId > 0 ? route.mappingId : null"
                    @input="(val) => updateFieldValue('mappingId', val)"
                />
            </li>
        </ul>
    </div>
</template>

<script>
    import CicSelect from '@/components/inputs/CicSelect';

    export default {
        name: 'PlayPrompt',
        components: {
            CicSelect,
        },
        props: {
            editing: {
                type: Boolean,
                default: false,
            },
            route: {
                type: Object,
                required: true,
            },
            mediaLists: {
                type: Array,
                required: true,
            },
        },
        emits: ['change'],
        computed: {
            prompts() {
                const list = this.mediaLists.find((x) => x.mediaListId === this.route.mappingType);
                return list?.prompts ?? [];
            },
            warning() {
                return (
                    this.route.mappingType &&
                    this.mediaLists.some((x) => x.mediaListId === this.route.mappingType && !x.allowed)
                );
            },
        },
        methods: {
            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
        },
    };
</script>
